export type Page<T> = {
    content: T[]
    last: boolean
}

export const unwrapPage = <T=any>(response: Page<T>):T[] => {
    if(response.content) {
        return response.content
    } else {
        throw new Error('A Object was tried to be unwrapped as a Page, but it was not a Page')
    }
}
